import {Injectable} from '@angular/core';

/**
 * Service to interact with the Profile API.
 * Provides methods to retrieve the users profile, loyalty, personal information etc.
 */

@Injectable({providedIn: 'root'})
export class RequestMaintenanceService {
  public mapBackendErrorToKey(message?: string): string {
    if (!message) return 'profile.request_maintenance.request_error_generic';

    const msg = message.toLowerCase();
    if (msg.includes('already submit')) {
      return 'profile.request_maintenance.request_error_already_requested';
    }
    if (msg.includes('address incomplete')) {
      return 'profile.request_maintenance.request_error_address';
    }
    // fallback
    return 'profile.request_maintenance.request_error_generic';
  }
}
